<template>
  <div v-if="detailData">

    <!-- <a-modal
        :width="330"
        title="分享好友"
        :visible="isShowShare"
        @ok="handleOk"
        @cancel="handleCancel"
    >
      <div>
        <div class="text-center w-200 h-200 mx-auto">
          <img class="block w-200 h-200 mx-auto" :src="qrcode" alt="">
        </div>
        <div class="text-center text-gray-501 pt-20">微信扫码分享给好友吧</div>
      </div>
    </a-modal> -->

    <div class="bg-white pb-50">
      <div class="container mx-auto">
        <div class="py-20">
          <a-breadcrumb separator=">">
            <a-breadcrumb-item><a href="/">首页</a></a-breadcrumb-item>
            <a-breadcrumb-item>{{ detailData.title }}</a-breadcrumb-item>
          </a-breadcrumb>
        </div>

        <div class="flex relative">
          <div class="ss-lesson-cover-img flex-none">
            <img :src="detailData.image" class="object-cover" alt="">
          </div>
          <div class="pl-30">
            <div class="relative">
              <div class="pr-60">
                <div class="text-30 text-gray-900 mb-20 ">{{ detailData.title }}</div>
                <div class="text-14 text-gray-501 mb-25">{{ detailData.extitle }}</div>
              </div>

            </div>

            <div class="ss-lesson-money bg-gray-200">
              <div class="flex items-center justify-between px-20 py-5">
                <div class="flex items-center">
                  <!-- <div class="pr-20 text-12 text-gray-501">价格</div>
                  <div>
                    <span class="text-orange-501 text-12">￥</span>
                    <span class="text-orange-501 text-30 font-bold"
                          v-if="detailData.price>0">{{ detailData.price }}</span>
                    <span class="text-orange-501 text-30 font-bold" v-else>免费</span>
                  </div> -->
                </div>
              </div>
            </div>
            <!-- 表示支付状态是没支付，但是没有结束 -->

            <div v-if="detailData.is_serial==1">
              <!-- 先判断购买 -->
              <div class="flex mt-25" v-if="detailData.price>0&& detailData.is_pay==0" @click="toBuy">
                <div class="text-12 bg-orange-501 text-white px-80 py-15 text-15 cursor-pointer">立即购买</div>
              </div>
              <div class="flex mt-25" v-else>
                <div class="text-12 bg-green-500 text-white px-80 py-15 text-15 cursor-pointer tosee"
                     @click="toSeeZhibo"> 查看直播
                </div>
              </div>
            </div>

            <!-- 判断是不是连载课 -->
            <div v-else>
              <!-- 先判断购买 -->
              <div class="flex mt-25" v-if="detailData.price>0 && detailData.is_pay==0" @click="toBuy">
                <div class="text-12 bg-orange-501 text-white px-80 py-15 text-15 cursor-pointer">立即购买</div>
              </div>

              <!-- 表示结束啦，但是可以看回放 -->
              <div class="flex mt-25" v-else-if="detailData.can_playback == 1&& live_status == 3">
                <!-- <div class="text-12 bg-gray-500 text-white px-80 py-15 text-15" v-if="detailData.playback_url ==''">回放生成中</div> -->
                <div class="text-12 bg-green-500 text-white px-80 py-15 text-15 cursor-pointer"
                     @click="getLive(detailData.id,2)">观看回放
                </div>
              </div>

              <!-- 表示结束啦，但是不可以看回放 -->
              <div class="flex mt-25" v-else-if="live_status == 3">
                <div class="text-12 bg-gray-501 text-white px-80 py-15 text-15">已结束</div>
              </div>

              <div class="flex mt-25" v-else-if="live_status == 2">
                <div class="text-12 bg-gray-501 text-white px-80 py-15 text-15">未开始</div>
              </div>

              <div class="flex items-center mt-25" v-else>
                <div class="text-12 bg-green-500 text-white px-80 py-15 text-15 cursor-pointer"
                     @click="getLive(detailData.id,1)">直播中
                </div>
                <div class="ml-10">
                  <a-tooltip placement="right">
                    <template slot="title">
                      <span>登录密码：{{ detailData.hty_info.user_key }}</span>
                    </template>
                    <!-- <div class="text-gray-501 text-12 pl-20">查看密码</div> -->
                  </a-tooltip>
                </div>
              </div>
            </div>

            <div class="absolute right-0 top-0 center cursor-pointer" @click="openShare" v-if="stateIsBind==1">
              <div class="flex w-32 h-32 rounded-full ss-wx-icon mx-auto"><span
                  class="iconfont icon-wx m-auto text-white text-16"></span></div>
              <div class="text-12 text-gray-501 pt-5">分享好友</div>
            </div>

          </div>
        </div>
      </div>


      <div class="mt-40 mb-100">
        <div class="container mx-auto">
          <div class="flex justify-between">
            <div class="ss-lesson-cont-l bg-white px-30 py-20 ss-center-box">
              <div>
                <a-tabs v-model="activeKey">
                  <a-tab-pane key="1" tab="课程介绍">
                    <div class="" v-html="detailData.remarks"></div>
                  </a-tab-pane>
                  <a-tab-pane key="2" tab="课程目录" v-if="detailData.is_serial==1">
                    <div class="course_catalogue">
                      <ul style="height:400px;">
                        <li v-for="(item,index) in sub_cate_list" :key="index">
                          <img src="../../assets/images/video.png" alt="" class="cate_img">
                          <i class="cate_text">{{ item.title }}</i>
                          <div v-if="item.live_status==3">
                            <button class="live_finish" v-if="detailData.can_playback==0">已结束</button>
                            <!-- 开启回放 -->
                            <button class="live_finish" v-else @click="getLive(item.id,2)">观看回放</button>
                          </div>
                          <div v-else-if="item.live_status==2">
                            <div v-if="detailData.is_bind_pub==1">
                              <button v-if="item.is_yuyue==false" class="live_order" @click="getOrder(item.id)">未预约
                              </button>
                              <button v-else class="live_order" @click="notStart">已预约</button>
                            </div>
                            <div v-else>
                              <button class="live_finish" @click="notStart">未开始</button>
                            </div>
                          </div>
                          <div v-else>
                            <button class="live_live" @click="getLive(item.id,1)">正在直播</button>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="flex justify-right pt-50 pb-30 float-right" v-if="totalNum>0">
                      <a-pagination v-model="pageNo" :defaultPageSize="7" :total="totalNum"
                                    @change="onPageChange(pageNo)" show-less-items/>
                    </div>
                  </a-tab-pane>

                </a-tabs>
              </div>
            </div>

            <div class="ss-lesson-cont-r bg-white px-30 pt-20 pb-30 self-start" v-if="detailData.teacher">
              <div>
                <div class="text-18 text-gray-900 mb-20 ss-lesson-cont-r-teacher pl-15">授课老师</div>
                <div class="flex py-10 items-center">
                  <div class="w-72 h-72 rounded-full">
                    <img class="w-72 h-72 ss-lesson-cont-r-teacher-img rounded-full"
                         :src="detailData.teacher.avatarUrl || mr_tx" alt="">
                  </div>
                  <div class="ml-15">
                    <div class="text-16 text-gray-900 pb-10">{{ detailData.teacher.name }}</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!--支付s-->
      <Pay :params="{content_type:30, is_team:0, content_id: id}"></Pay>
      <!--支付e-->

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailData: {}, // 详情数据
      id: 0, // 详情数据id
      qrcode: '', // 小程序码
      isShowShare: false, // 是否打开分享弹框
      live_status: 2, // 1：直播中 2：未开始 3：已结束
      sub_cate_list: {},// 直播目录列表
      totalNum: 0,// 总共的页码数
      pageNo: 1,// 起始的页码数
      activeKey: '1',// 默认tab页高亮展示
      is_pay: 0,//默认商品的支付状态
      mr_tx: 'https://qxystatic.qingxiaoyun.com/qxy/20200807/5f2d25ab58753.png' // 默认头像
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getLiveData()
  },
  methods: {
    // 获取直播详情
    async getLiveData() {
      const {data: res} = await this.$http.get('index.php/internal/live_detail', {id: this.id, is_bind_pub: 0})
      console.log(res, 'dd')
      this.detailData = res
      this.live_status = res.live_status
    },
    handleOk() {
    },

    handleCancel() { // 点击了取消
      this.closeShare()
    },

    closeShare() { // 关闭
      this.isShowShare = false
    },

    openShare() { // 关闭
      this.isShowShare = true
    },

    // toBuy(){ // 支付
    //   if (!this.stateXtoken) return  (this as any).mutationOpenLogin(true); // 没有登录提示登录
    //   if (this.detailData.price>0  && this.detailData.is_pay==0) {
    //     // (this as any).mutationOpenPay(true);
    //     this.$router.push({path:`/Payment/Cart?id=${this.id}&sign=live`})
    //     return false
    //   }  else {
    //     return true
    //   }
    // },

    toLiveDetail(type) { // 去直播详情
      // if (!this.toBuy()) return;  // 是否不是免费并且没有支付
      let routeUrl
      switch (type) {
        case 1: // 直播中
          routeUrl = this.$router.resolve({path: '/live/liveDetail?course_id=' + this.detailData.hty_info.course_id + '&id=' + this.id + '&isplayback=' + 0});
          window.open(routeUrl.href, '_blank');
          break;
        case 2: // 回放
          routeUrl = this.$router.resolve({path: '/live/liveDetail?playback_url=' + this.detailData.playback_url + '&id=' + this.id + '&isplayback=' + 1});
          window.open(routeUrl.href, '_blank');
          break;
      }
    },
    async getOrder(id) {//点击预约直播
      // console.log(this.is_pay)
      // if(this.is_pay==0){// 未支付
      //   this.$message.info('请先购买该直播')
      // }else{// 已经支付
      var res_1 = await this.$http.post('gw_pcschool/yuyue', {live_id: id})
      if (res_1.code === 200) {
        this.$message.success('预约成功，在开播前会收到提醒')
        this.serial_sub_live()
      }
      // }
    },
    async getLive(id, type) {//点击回放或者去直播跳转
      // 传递的是父级id
      var res_1 = await this.$http.get('gw_pcschool/hty_info', {
        params: {id: id, type: type}
      });
      if (res_1.code === 200) {
        // window.open(res_1.data)
        // console.log(res_1.data)
        this.$router.push('/live/liveDetail?playback_url=' + res_1.data + '&id=' + this.id + '&isplayback=' + 1)
      } else {
        // this.$message.error(res_1.error)
      }
    },

    async getPage() {// 分页的操作
      const res_2 = await this.$axios.$get('gw_pcschool/serial_sub_live', {
        params: {
          id: this.id,
          pageNo: this.pageNo,
          pageSize: 7
        }
      });// 获取直播子目录
      this.sub_cate_list = res_2.data.data
    },
    onPageChange(pageNo) {
      this.pageNo = pageNo;
      this.getPage()
    },

    notStart() {// 点击还未开播事件
      if (this.is_pay == 0) {// 未支付
        this.$message.error('请先购买该直播')
      } else {
        this.$message.info('直播还未开始哦！')
      }
    },

    toSeeZhibo() {// 点击去看直播的事件
      this.activeKey = '2'
    },
  }
}
// import {Component, Vue} from 'vue-property-decorator'
// import {getItem} from '../../assets/js/utils'
// import {State, Mutation} from 'vuex-class';
// var d:any = {}
// var s:any = {}

// @Component({
//   async asyncData(app: any) {
//     const id = app.query.id;
//     const res_1 = await app.$axios.$get('gw_pcschool/live_detail', {params: {id}});
//     const res_2=await app.$axios.$get('gw_pcschool/serial_sub_live',{params:{id,pageNo:1,pageSize:7}});// 获取直播子目录

//     d = res_1.data
//     s = app.store.state.seo

//     if (res_1 && res_1.code == 200) {
//       return {
//         detailData: res_1.data,
//         live_status: res_1.data.live_status,
//         is_pay:res_1.data.is_pay,
//         id,
//         sub_cate_list:res_2.data.data,
//         totalNum:res_2.data.totalNum,
//       }
//     } else if (res_1 && res_1.code == 400) {
//       setTimeout(() => {
//         app.app.router.go(-1)
//       }, 100)
//     }
//   },
//   head() {
//     return {
//       title:  d.title + '-' + s.seo_title ,
//       meta: [
//         {
//           name: 'keywords',
//           content: '直播'
//         },
//         {
//           name: 'description',
//           content: d.extitle
//         }
//       ]
//     }
//   }
// })
// export default class liveList extends Vue {

//   @State('xtoken') stateXtoken: string | undefined;    // xtoken
//   @State('isBind') stateIsBind: any; //是否有公众号或者二维码
//   @Mutation('openLogin') mutationOpenLogin: ((arg0: boolean) => void) | undefined; // 打开登录弹框
//   @Mutation('openPay') mutationOpenPay: ((arg0: boolean) => void) | undefined; // 打开支付弹框
//   $axios: any;
//   $message: any;

//   mounted() {
//     this.get_qrcode()
//   }
//   async serial_sub_live(){
//     var res_1=await this.$axios.$get('gw_pcschool/live_detail', {params: {id:this.id}});
//     var res_2=await this.$axios.$get('gw_pcschool/serial_sub_live',{params:{id:this.id,pageNo:1,pageSize:7}});
//     this.detailData=res_1.data,
//     this.sub_cate_list=res_2.data.data,
//     this.live_status=res_1.data.live_status
//   }

//   async get_qrcode() { // 获取小程序码
//     var res_1 = await this.$axios.$post('gw_pcschool/qrcode', {
//       path: 'pages/live/liveDetail/liveDetail',
//       params: {id: this.id}
//     });
//     this.qrcode = res_1.data.qrcode;
//   }

//   handleOk() {
//   }

//   handleCancel() { // 点击了取消
//     this.closeShare()
//   }

//   closeShare() { // 关闭
//     this.isShowShare = false
//   }

//   openShare() { // 关闭
//     this.isShowShare = true
//   }

//   toBuy(){ // 支付
//     if (!this.stateXtoken) return  (this as any).mutationOpenLogin(true); // 没有登录提示登录
//     if (this.detailData.price>0  && this.detailData.is_pay==0) {
//       // (this as any).mutationOpenPay(true);
//       this.$router.push({path:`/Payment/Cart?id=${this.id}&sign=live`})
//       return false
//     }  else {
//       return true
//     }
//   }

//   toLiveDetail(type: number) { // 去直播详情
//     if (!this.toBuy()) return;  // 是否不是免费并且没有支付
//     let routeUrl
//     switch (type) {
//       case 1: // 直播中
//         routeUrl = this.$router.resolve({path: '/live/liveDetail?course_id=' +  this.detailData.hty_info.course_id +'&id=' + this.id + '&isplayback=' + 0});
//         window.open(routeUrl.href, '_blank');
//         break;
//       case 2: // 回放
//         routeUrl = this.$router.resolve({path: '/live/liveDetail?playback_url=' +  this.detailData.playback_url + '&id=' + this.id+ '&isplayback=' + 1});
//         window.open(routeUrl.href, '_blank');
//         break;
//     }
//   }
//   async getOrder(id:any){//点击预约直播
//   // console.log(this.is_pay)
//   // if(this.is_pay==0){// 未支付
//   //   this.$message.info('请先购买该直播')
//   // }else{// 已经支付
//      var res_1=await this.$axios.$post('gw_pcschool/yuyue',{live_id:id})
//     if(res_1.code===200){
//       this.$message.success('预约成功，在开播前会收到提醒')
//       this.serial_sub_live()
//     }
//   // }
//   }
//   async getLive(id:any,type:any){//点击回放或者去直播跳转
//   // 传递的是父级id
//      var res_1 = await this.$axios.$get('gw_pcschool/hty_info', {
//       params: {id:id,type:type}
//     });
//      if(res_1.code===200){
//       // window.open(res_1.data)
//       // console.log(res_1.data)
//      this.$router.push('/live/liveDetail?playback_url='+res_1.data + '&id=' + this.id+ '&isplayback=' + 1)
//     }else{
//       // this.$message.error(res_1.error)
//     }
//   }

//   async getPage(){// 分页的操作
//      const res_2=await this.$axios.$get('gw_pcschool/serial_sub_live',{params:{id:this.id,pageNo:this.pageNo,pageSize:7}});// 获取直播子目录
//      this.sub_cate_list=res_2.data.data
//   }
//   onPageChange(pageNo:any){
//      this.pageNo=pageNo;
//       this.getPage()
//   }

//   notStart(){// 点击还未开播事件
//    if(this.is_pay==0){// 未支付
//      this.$message.error('请先购买该直播')
//    }else{
//     this.$message.info('直播还未开始哦！')
//     }
//   }

//   toSeeZhibo(){// 点击去看直播的事件
//      this.activeKey='2'
//   }
// }


</script>


<style scoped>
.ss-lesson-money {
  width: 470px;
}

.ss-lesson-cover-img, .ss-lesson-cover-img img {
  width: 450px;
  height: 280px;
  background: #eee;
}

.ss-lesson-cont-l {
  width: 890px;
}

.ss-lesson-cont-r {
  width: 290px;
}

.ss-lesson-cont-r-teacher {
  border-left: 4px solid #5173f5
}

.ss-lesson-cont-r-teacher-img {
  width: 72px;
  height: 72px;
}

>>> .ant-collapse-borderless {
  background: none !important;
}

.ss-wx-icon {
  background: #26bc65;
  box-shadow: 0 5px 8px 0 rgba(38, 188, 101, 0.3);
}

>>> .ant-modal-footer {
  display: none;
}

.course_catalogue li {
  width: 100%;
  height: 48px;
  padding: 15px 0px 15px;
  border-bottom: 1px solid #ccc;
  position: relative;
  margin-bottom: 10px;
  padding-left: 20px;
}

.course_catalogue li button {
  position: absolute;
  right: 10px;
  bottom: 12px;
  color: #fff;
  font-size: 12px;
}

.live_finish {
  width: 70px;
  height: 34px;
  background-color: silver;
  border-radius: 4px;
}

.live_back {
  width: 70px;
  height: 34px;
  background-color: #333;
  border-radius: 4px;
}

.live_order {
  width: 70px;
  height: 34px;
  background-color: #fd7947;
  border-radius: 4px;
}

.live_live {
  width: 70px;
  height: 34px;
  background-color: rgb(68, 176, 113);
  border-radius: 4px;
}

.cate_img {
  width: 25px;
  position: absolute;
  bottom: 15px;
  left: 15px;
}

.cate_text {
  position: absolute;
  top: 10px;
  left: 50px;
  font-style: normal;
}

.tosee {
  text-decoration: none;
  color: white;
}
</style>
